import { Injectable, inject } from '@angular/core'
import { ListPopoverMessageComponent } from '../../shared/components/list-popover-message/list-popover-message.component'
import { PopoverController, PopoverOptions } from '@ionic/angular/standalone'

@Injectable({
	providedIn: 'root'
})
export class ListPopoverMessageService {
	private popoverController = inject(PopoverController)
	private readonly baseCssClass = ['custom-popover', 'custom-popover--bubble']

	async presentPopover<T>(
		options: { title: string; action?: () => void }[],
		ev: Event,
		message: string,
		listed: boolean = true,
		additionalOptions?: T & Partial<PopoverOptions>
	): Promise<HTMLIonPopoverElement> {
		const defaultPopoverOptions: PopoverOptions = {
			component: ListPopoverMessageComponent,
			componentProps: { options, listed, message },
			event: ev,
			arrow: false,
			dismissOnSelect: true,
			showBackdrop: false,
			cssClass: this.baseCssClass
		}

		const mergedOptions: PopoverOptions = {
			...defaultPopoverOptions,
			...additionalOptions,
			cssClass: this.mergeCssClass(this.baseCssClass, additionalOptions?.cssClass)
		}

		const popover = await this.popoverController.create(mergedOptions)

		await popover.present()

		return popover
	}

	private mergeCssClass(base: string | string[], extra?: string | string[]): string[] {
		const normalize = (value?: string | string[]) => {
			if (!value) return []
			return (Array.isArray(value) ? value : value.split(/\s+/)).map(item => item.trim()).filter(Boolean)
		}

		return Array.from(new Set([...normalize(base), ...normalize(extra)]))
	}
}
